import axios from "axios";

const KEY = "AIzaSyCDFbM7nnA2g9GgbySpGfPCNyMq9PHtoXg";

export default axios.create({
    baseURL: "https://www.googleapis.com/youtube/v3",
    params: {
        part: "snippet",
        type: "video",
        maxResults: 5,
        key: KEY
    }
});